import styled from "styled-components";

const Style = styled.div`
  flex: 1;
  padding: 0px;
  display: flex;
  justify-content: center;

  .g2-tooltip {
    z-index: 102 !important;
  }
`;

export default Style;
